import {
  CLEAR_VIDEO_CATEGORIES,
  SET_VIDEO_CATEGORIES,
  SET_VIDEO_CATEGORIES_MOVEMENT,
  SET_VIDEO_CATEGORIES_ASSESSMENT,
  SET_PARENT_VIDEO_CATEGORIES,
} from 'store/types/video-catergory';

const initialState = {
  videoCategories: [],
  videoCategoriesMovement: [],
  videoCategoriesAssessment: [],
  parentVideoCategories: [],
};

const videoCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VIDEO_CATEGORIES:
      return {
        ...state,
        videoCategories: action?.payload,
      };
    case SET_VIDEO_CATEGORIES_MOVEMENT:
      return {
        ...state,
        videoCategoriesMovement: action?.payload,
      };
    case SET_VIDEO_CATEGORIES_ASSESSMENT:
      return {
        ...state,
        videoCategoriesAssessment: action?.payload,
      };
    case SET_PARENT_VIDEO_CATEGORIES:
      return {
        ...state,
        parentVideoCategories: action?.payload,
      };
    case CLEAR_VIDEO_CATEGORIES:
      return {
        ...state,
        videoCategories: initialState.videoCategories,
        videoCategoriesMovement: initialState.videoCategoriesMovement,
        videoCategoriesAssessment: initialState.videoCategoriesAssessment,
        parentVideoCategories: initialState.parentVideoCategories,
      };
    default:
      return state;
  }
};

export default videoCategoryReducer;
